import BaseService from '../baseService'
import { QueryBuilder } from '../utils'

import { isNil } from '@solta/ramda-extra'

export class UserService extends BaseService {
  fetchUsers({ q, filters, limit, start }, signal) {
    const searchParams = QueryBuilder()
      .setQ(q)
      .setFilters(filters)
      .setPaging({ start, limit })
      .build()

    return this.client.get(`users/?${searchParams}`, { signal }).json()
  }

  fetchUser(id) {
    if (isNil(id)) throw new Error('Please provide an user id')

    return this.client.get(`users/${id}`).json()
  }
}
